export default {
    'sass-sent-simp': {
      'title': 'SASS: Data and Methods for Subject Aware Sentence Simplification',
      'key': 'sass-sent-simp',
      'date': '2020-12-14',
      'tags': ['research'],
      'docBodyHtml': `
      In a new <a href='https://drive.google.com/file/d/1Rz35LBv15XQRDdiWC5xjcdXUL5GE6GqT/view?usp=sharing'>paper</a> 
      (and <a href='https://docs.google.com/presentation/d/1qyJ1oJRRUXdCz4oTw9wnQpN0jFOR-ZwlgKmDocG3hAI/edit?usp=sharing'>presentation</a>) under the guidance of Professor <a href='https://hhexiy.github.io/'>He He</a>, we explore an answer to a remarkably pesky question: what does it mean to simplify?
      
      <div class="bp3-card">
        <p class=".modifier">
        Sentence simplification tends to focus on the generic simplification of sentences by making them more readable and easier to understand. This  paper  provides a dataset aimed  at  training  models  that  perform  subject  aware  sentence  simplifications  rather  than  simplifying sentences as a whole.  We also test models on that  dataset  which  are  inspired  by  model  architectures  used  in  abstractive  summarization. We  hand  generated  portions  of  the  data  and augment  the  dataset  by  further  manipulating those hand written simplifications. Our results show  that  data-augmentation, data-masking, and model architecture  choices used in  summarization provide a solid baseline for comparison on subject aware simplification.
        </p>
      </div>
      `
    },
    'doc-summ': {
      'title': 'Long Document Summarization',
      'key': 'doc-summ',
      'date': '2020-12-01',
      'tags': ['research'],
      'docBodyHtml': `
      In a <a href='https://drive.google.com/file/d/1QmPOt9YyyWidPOGN4WS5y4Ot0COPCg9x/view?usp=sharing'>paper</a>
      still under submission, we outline the task of summarizing long documents with heavy domain-specific words in low-resource settings. We assemble a dataset of public legal briefs and use expert annotations to identify key points, then use a two-step pipeline to extract-then-summarize.
      This paper was done through my professional work and in collaboration
      with students at UMass Amherst. 
      
      <br /> <br />
        Here's the abstract:
        <br />
        <div class="bp3-card">
          <p class=".modifier">
            Abstractive summarization is the task of compressing a long document into a coherent short document while retaining salient information. Modern abstractive summarization methods are based on deep neural networks which are data hungry algorithms. Since collecting summarization datasets is expensiveand time-consuming task, practical industrial settings are usually low-resource. In this paper, we study a challenging low-resource setting of summarizing long legal briefs with average source document length 4268 words and only 120 available (document, summary) pairs. To account for the data scarcity, we used a modern pretrained abstractive summarizer BART (Lewis et al., 2020), but noticed it is only able to achieve 17.9 ROUGE-L as struggles with long documents. Hence, we attempt to compress these long documents by identifying salient sentences in the source which best ground the summary, using a novel algorithm based on GPT2 (Radford et al., 2019) language model perplexity scores that operates within the low resource regime. On feeding the compressed documents to BART, we observe a 6.0 ROUGE-L improvement, and our method also beats several competitive salience detection baselines. Furthermore, our identified salient sentences tend to agree with an in-dependent human labeling by domain experts.
          </p>
           </div>
      `
    },
    'trees-game-1': {
      'title': 'Quarantine Project: Photosynthesis',
      'key': 'trees-game-1',
      'date': '2020-11-22',
      'tags': ["application development"],
    },
    'qd-rl-1': {
      'title': `Quality Diversity in Reinforcement Learning: Progress on Work`,
      'key': 'qd-rl-1',
      'date': '2020-11-22',
      'tags': ['research'],
      'docBodyHtml': `
Quality diversity is a school of reinforcement learning algorithms which maintain an abundance of good-yet-different
solutions rather than optimize for a specific goal. <br /> <br />
In our a working <a href="https://drive.google.com/file/d/1HCDLNPCOfb9KzZUyT5pWELu1FIaBUL6x/view?usp=sharing"> paper </a>
with Prof Julian Togelius, we explore how members of this class of of algorithms can outperform simple evolutionary search.
<br /> <br />
Our paper is essentially a negative result; for our toy problem, we have yet to find meaningful improvements.
However, we do come away with a better characterization of these algorithms, and promising directions for our continued work.
  
<br /> <br />
Here's the abstract:
<br />
<div class="bp3-card">
  <p class=".modifier">
The Reinforcement Learning field is strong on achievements and weak
on reapplication; a computer playing GO at a super-human level is still
terrible at Tic-Tac-Toe. This paper asks whether the method of training
networks improves their generalization. Specifically we explore core quality
 diversity algorithms, compare against two recent algorithms, and propose
  two new algorithms to deal with shortcomings in existing methods.
Our work raises important points about the choice of behavior criterion in
quality diversity, the interaction of differential and evolutionary training
methods, and the role of offline reinforcement learning and randomized
learning in evolutionary search.
      </p>
    </div>
      `
    },
    'enc-dec': {
      'title': 'An Updated Encoder-Decoder Tutorial',
      'key': 'enc-dec',
      'date': '2020-11-22',
      'tags': ['research', 'bug report'],
      'docBodyHtml': `
      I wrote this after seeing Fracois Chollet's similar <a href='https://blog.keras.io/a-ten-minute-introduction-to-sequence-to-sequence-learning-in-keras.html'> encoder-decoder tutorial </a>. 
      Encoder-decoders are fairly universal solutions to sequence to sequence problems, like translation or sentence simplification.
      <br /> <br />
      What's great about this version?
        <ul>
          <li>It uses <a href="https://arxiv.org/abs/1907.11692">Roberta</a>, a well-trained model from the BERT family</li>
          <li>The Hugging Face <a href="https://huggingface.co/transformers/index.html">transformers</a> will let you upgrade to other models</li>
          <li>It's based on pytorch</li>
          <li>There are two toy problems for testing encoder-decoder training, based on the num2words package</li>
        </ul>
      See Training and Evaluation Code, and bottom for other details. <br />
      <h3>Training and Evaluation code</h3>
      <Pre>
import logging
import random
import torch
from num2words import num2words
from transformers import EncoderDecoderModel, RobertaTokenizer, AdamW

"""
PARAMETERS AND LOGGING
"""
model_name = 'roberta-base'
run_name = 'numbers'

epochs = 50
batch_size = 64
learning_rate = 3e-5
device = 'cpu'

log_file_name = './{}-{}-epch-{}-batch-{}-lr-{}-out.log'.format(run_name, model_name, epochs, batch_size, learning_rate)
logging.basicConfig(filename=log_file_name, level=logging.INFO)
logging.getLogger().addHandler(logging.StreamHandler())

"""
DATASETS
"""
def say_numbers():
    """
    100 -> one hundred
    """
    amount = 500
    data = [
        (str(i), num2words(i))
        for i in range(amount)
    ]
    random.shuffle(data)

    return data

def count_next_number():
    """
    one hundred -> one hundred and one
    """
    amount = 501
    data = [num2words(i) for i in range(amount)]
    paired = [(d1, d2) for d1, d2 in zip(data, data[1:])]
    return paired


def eng_fra_data():
    """
    one -> un
    curl -O http://www.manythings.org/anki/fra-eng.zip
    unzip fra-eng.zip
    """
    data_path = './fra.txt'
    data = []
    with open(data_path, 'r', encoding='utf-8') as f:
        lines = f.read().split('\\n')

        for line in lines[:10000]:
            input_text, target_text, _ = line.split('\\t')
            data.append((input_text, target_text))

    return data


def divide_chunks(l, n):
    # looping till length l
    for i in range(0, len(l), n):
        yield l[i:i + n]



"""
SET UP TRAINING DATA AND MODEL
"""
def tokenize(text):
    toks = tokenizer.encode(text)
    return pad_to_len(toks)


def pad_to_len(toks, max_len=15):
    if len(toks) <= max_len:
        return toks + [0] * (max_len - len(toks))
    return toks[:max_len]


data_encoded = say_numbers()

train_len = int(0.9 * len(data_encoded))
train_data = data_encoded[:train_len]
test_data = data_encoded[train_len:]
logging.info('len train %d, len test, %d', len(train_data), len(test_data))

tokenizer = RobertaTokenizer.from_pretrained(model_name)
model_save_dir = '/Users/bradwindsor/gs_projects/transformers/training/'

model = EncoderDecoderModel.from_encoder_decoder_pretrained(model_name, model_name)
model.train()
model.to(device)


"""
TRAIN
"""
total_steps = epochs * int(len(train_data) / batch_size)
optimizer = AdamW(model.parameters(), lr=learning_rate)

# warmup_frac = 0.1
# scheduler = get_linear_schedule_with_warmup(optimizer, total_steps * warmup_frac, total_steps)

logging.info('first datapoint')
logging.info(str(train_data[0][0]))
logging.info(str(tokenize(train_data[0][0])))
logging.info(str(train_data[0][1]))
logging.info(str(tokenize(train_data[0][1])))
logging.info('beginning train')


for epoch in range(epochs):
    cume_loss = 0
    for chunk in divide_chunks(train_data, batch_size):
        inp_ids = torch.tensor([tokenize(e[0]) for e in chunk]).to(device)
        out_ids = torch.tensor([tokenize(e[1]) for e in chunk]).to(device)
        optimizer.zero_grad()
        loss, _, _, _ = model(input_ids=inp_ids, decoder_input_ids=out_ids, labels=out_ids)
        loss.backward()
        optimizer.step()
        # scheduler.step()
        logging.info('...loss %f', loss.item())
        cume_loss += loss.item()

    if epoch % 999 == 0:
        model.save_pretrained(model_save_dir)

    logging.info('epoch %d, loss %d', epoch, cume_loss)


"""
RUN INFERENCE
"""
def run_snip(snip, name):
    inp_ids = torch.tensor([tokenize(e[0]) for e in snip]).to(device)
    generated = model.generate(inp_ids, decoder_start_token_id=model.config.decoder.pad_token_id)
    logging.info('%s data %s', name, str(snip))
    logging.info('generated %s', str(generated))

    gen = generated.cpu().numpy()
    for row in gen:
        logging.info(str(row))
        logging.info(str(tokenizer.decode(row)))


snip = train_data[:10]
run_snip(snip, 'train')
snip = test_data[:10]
run_snip(snip, 'test')
</Pre>
<h3>Modifications to use a local or pretrained model</h3>
Huggingface will automatically download Roberta, but perhaps you want to use a pretrained model. In that case, do this:<br /> <br />
<Pre>
model_path = '/home/training/roberta-full/'
tokenizer = RobertaTokenizer.from_pretrained(model_path)
encoder_decoder_config = EncoderDecoderConfig.from_pretrained(model_path)
model = EncoderDecoderModel.from_pretrained(model_path, config=encoder_decoder_config)
</Pre>


`
    },
    '005': {
      'title': 'Javascript and Python Rosetta Stone',
      'key': '005',
      'date': '2020-08-09',
      'tags': ['application development'],
    'docBodyHtml': `
      For the many people who learn either python or javascript, it is worth noting that
      how incredibly close you are to using the other. One reason is that JSON is the
      language of REST calls and as such, both languages deal with lists
      [] and maps {}. Here is an abridged translation:
      <table class="bp3-html-table .modifier">
        <thead>
          <tr>
            <th>Task</th>
            <th>Python</th>
            <th>Javascript</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Create and filter a list</td>
            <td>
<Pre>
a = [1, 2, 3, 4]
[n for n in a if not n % 2 == 0]

<i>[1, 3]</i>
</Pre>
            </td>
            <td>
<Pre>
let a = [1, 2, 3, 4];
a.filter(n => n % 2 !=0);

<i>[1, 3]</i>
</Pre>
            </td>
          </tr>
          <tr>
            <td>Create two maps and merge them</td>
            <td>
<Pre>
one = {'a': 1}
two = {'b': b}
{**one, **two}

<i>{a: 1, b: 2}</i>
</Pre>
            </td>
            <td>
<Pre>
let one = {'a': 1}
let two = {'b': b}
{...one, ...two}

<i>{a: 1, b: 2}</i>
</Pre>
            </td>
          </tr>
          <tr>
            <td>Print each element in <br />
             a list with a running counter</td>
            <td>
<Pre>
a = [1, 2, 3, 4]
for i, ele in enumerate(a):
    print(ele, i)


<i>1, 0...</i>
</Pre>
            </td>
            <td>
<Pre>
let a = [1, 2, 3, 4];
a.forEach((ele, i) => {
    console.log(ele, i);
}

<i>1, 0...</i>
</Pre>
            </td>
          </tr>
          <tr>
            <td>Sort then map</td>
            <td>
<Pre>
cities = [{"city":"new york", "land_area":302.6},
          {"city":"seattle", "land_area":83.9},
          {"city":"kansas city", "land_area":315}]]
cities = sorted(cities, key=lambda x: x[‘land_area’])
cities = [c[‘city’] for c in cities]


<i>[‘new york’, ‘seattle’, ‘kansas city’]</i>
</Pre>
            </td>
            <td>
<Pre>
let cities = [{"city":"new york", "land_area":302.6},
              {"city":"seattle", "land_area":83.9},
              {"city":"kansas city", "land_area":315}];

cities = cities.sort((a, b) =>  {a.land_area - b.land_area})
               .map((d)  => d.city );

<i>[‘new york’, ‘seattle’, ‘kansas city’]</i>
</Pre>
            </td>
          </tr>
          <tr>
            <td>Accumulate on each <br />
             element of a list</td>
            <td>
<Pre>
area_km = 0
for d in cities:
    area_km += d[‘land_area’] * 2.6

<i>1823.9</i>
</Pre>
            </td>
            <td>
<Pre>
let areas_km = cities.reduce( (acc, d) => {
                          acc += d.land_area * 2.6;
                      }, 0);

<i>1823.9</i>
</Pre>
            </td>
          </tr>
        </tbody>
      </table>
      `
    },
    '004': {
      "title": "4 Problems in NLP We've Tried to Solve But Haven't Yet",
      'key': '004',
      "date": "2020-07-03",
      "tags": ["research"],
      "docBodyHtml": `
      We've solved the Turing test: since 1980 there have been computers
      which we can't tell apart from humans. We have Alexa in our homes,
      Google answers our questions, Siri pulls up our favorite songs or movies on command.
      With so much done, what is there in NLP which we can't yet do?
      <br /><br /><h4>Technical question answering</h4>
      A computer can't answer quetions like 'Why is Microsoft Word broken?'. See the <a href='https://www.aclweb.org/anthology/W15-4640.pdf'>
      Ubuntu dialogue corpus</a>; attempts to provide helpful answers are at <a href='https://arxiv.org/pdf/2003.04976.pdf'>
      5% F1</a>, or the <a href='https://leaderboard.techqa.us-east.containers.appdomain.cloud'/>
      IBM TechQA dataset</a>, where results are working ~50% of the time.
      <br /> <br />
      While <a href='https://arxiv.org/pdf/1909.01958.pdf'>
      getting an "A" on a 12-th grade science exam</a>
      is a notable example of solving hard questions with a book as reference, and there are some attempts to build bots to
      <a href='https://www.techrepublic.com/article/want-to-be-a-better-programmer-try-microsofts-code-writing-question-answering-stack-overflow-bot/'>
      help answer Stack Overflow questions</a>,
      we are a long way from doing this for any domain and reference material.
      <br /> <br />Lastly, the best answer to "Why isn't my Arch installation working?" might begin,
      "Do you see your bootloader start on startup?" dialogue and investigation are part of any help desk.

      <br /><br /><h4>Lifelong Learning</h4>
      Given enough data, we can teach a network to do anything. Do we always need new data to do new things though?
      <br />
      Reusing past learning is arguably the goal of expressing knowledge in an explicit format (as with knowledge bases or formal logic)
      or language models. And while there is evidence with <a href='https://arxiv.org/pdf/2005.14165.pdf'>GPT-3</a> that sufficient pre-training on
      large enough corposes of text can help solve many problems with just a few (or one) examples,
      much neural network fine-tuning suffers from a problem called "catastrophic forgetting";
      the more you train for one task, the less suited you are for another.
      <br />
      Having a system which continuously accumulates knowledge from prior tasks and uses it for future tasks
      is the goal of a paradigm known as <a href='https://www.cs.uic.edu/~liub/lifelong-machine-learning-draft.pdf'>
      lifelong learning</a> (a superset of transfer learning), and it is, as of yet, unsolved.

      <br /><br /><h4>A Persuasive AI </h4>
      I know, I know, IBM's Project Debater <a href='https://www.youtube.com/watch?v=m3u-1yttrVw'>won a broadcast debate against a human</a>. Yet the constraints in that debate (has to be Wikipedia-referenceable)
      and in the debate's sub-genre (nothing open-ended like "propose a plan to do X"), as well as
      IBM's own continuing work on this topic,
      point to this being an unfinished area. More generally, these efforts
      seem focused on appearing logical to a panel of impartial judges -- anyone who's ever
      tried to <a href='https://genius.com/The-fray-how-to-save-a-life-lyrics'>convince a friend</a>
      knows changinging viewpoints is a matter of facts, feelings, motivations, and personal experiences.
      You might even start by <a href='https://mygestaltherapy.com/what-is-the-socratic-method-how-to-persuade-anyone/'>
      accepting their view</a>.
      <br /> <br />
      When Alexa can persuade me I should exercise today, I should change my political party, take one
      job offer over another, or make peace with the person I'm fighting, that will feel like a different AI.

      <br /><br /><h4>Explain like I'm 5 </h4>
      "If you truly understand your PhD Thesis, you'll be able to explain it to a
      5-year old." While there are
      <a href='https://www.quora.com/What-is-your-PhD-thesis-in-one-sentence'>
        multiple
      </a>
      <a href='https://lolmythesis.com/'>
        websites
      </a>
      devoted to this, we're pretty far from being able to read a scientific
      paper ("Subjective Social Status and Major  Depression: A Path Analysis of
      Biological and Psychosocial Mechanisms") and re-express it in common terms
      ("Feeling nervous about what others think of you makes you depressed.")
      There's at least <a href='https://research.fb.com/wp-content/uploads/2019/07/ELI5-Long-Form-Question-Answering.pdf'>one paper</a>,
      and much related work in abstractive summarization and
      sentence simplification, but both are incomplete.

      <br /><br /><h4>And every other</h4>
      The problem space of natural language processing is anything which has
      been accomplished with writing or spoken word. Anything which has been done with human words or thoughts,
      and not yet with a computer, is an unsolved part.
      `
    },
    '003': {
      'key': '003',
      'title': 'New Paper: Causality and Batch RL',
      'date': '2020-06-03',
      'tags': ['research'],
      'docBodyHtml':`
        Written with professor Joan Bruna in the <a href='http://mathsdl-spring20.willwhitney.com/'>Mathematics of Deep Learning course</a>,
        our group released a <a href='https://arxiv.org/abs/2006.02579'>paper</a>
         about the intersection of two different fields related to AI:
        <a href='https://en.wikipedia.org/wiki/Causality'>causality</a> and offline (batch)
        <a href='https://en.wikipedia.org/wiki/Reinforcement_learning'>reinforcment learning</a>.
        We argue that these are different fields which tackle the same problem with similar
        mathematical models.


        <br /> <br />
        Here's the abstract:
        <br />
        <div class="bp3-card">
          <p class=".modifier">
            Reinforcement learning algorithms have had tremendous successes in online learning settings.
            However, these successes have relied on low-stakes interactions between the algorithmic agent and its environment.
            In many settings where RL could be of use, such as health care and autonomous driving, the mistakes made by most online RL algorithms during early training come with unacceptable costs.
            These settings require developing reinforcement learning algorithms that can operate in the so-called batch setting, where the algorithms must learn from set of data that is fixed, finite, and generated from some (possibly unknown) policy.
            Evaluating policies different from the one that collected the data is called off-policy evaluation, and naturally poses counter-factual questions. In this project we show how off-policy evaluation and the estimation of treatment effects in causal inference are two approaches to the same problem, and compare recent progress in these two areas.
          </p>
        </div>
      `,
    },
    '002': {
      "key": '002',
      "title": "How to handle the 'I have an App idea, can you help?' conversation",
      "date": "2020-03-01",
      "docBodyHtml":`
      Having someone from a business school pitch an app idea is a common-enough situation to merit its own
      <a href='https://whartoniteseekscodemonkey-blog.tumblr.com/'>tumblr blog</a>
      and <a href='https://www.reddit.com/r/AskReddit/comments/fknqc2/coders_of_reddit_how_do_you_politely_refuse_your/'>
        Reddit threads</a>, many of which are less than helpful.
      <br /> <br />
      Let's instead consider instead how great it is to have people who thinking creatively about technology and new applications.
      Next time someone reaches out to you about an app idea, <strong>show them the steps to prove their idea is a great one.</strong> This might look like:
      <ul>
      <li>Use Invisionapp or the like to build a mock-up that looks and acts like the real thing</li>
      <li>Show the mock-up to everyone they know and watch how users interact with it</li>
      <li>Make a market research survey get people to fill it out</li>
      <li>Drop $100 on internet ads to see the level of interest you get</li>
      </ul>
      A product manager can do much of the product design and business planning without an engineer. And if they assemble the evidence and test the design, who knows, someone might build it.

      `,
      "tags": ["application development"]
    },
    '001': {
      "key": '001',
      "title": "So why include that package-lock.json?",
      "date": "2019-10-01",
      "tags": ["bug report", "application development"],
      "docBodyHtml": `
      In javascript, package-lock.json seems a fairly extraneous byproduct of npm's build system. At first it seems like you wouldn't want to add it to your repo:
      <ol>
        <li>package-lock.json isn't used by the application to run at all </li>
        <li>package-lock.json gets regenerated when you run npm install, which you'll do anyway </li>
        <li>package-lock.json can actually make it harder to run an install, if some of your libraries have more recent versions you have to
        remove package-lock.json before an install will work.</li>
      </ol>
      <br />
      Yet there's one really good reason why you should ignore all the above and absolutely include it:
      <ol>
        <li>package-lock.json records exactly which package you installed. If you did npm install <package-name>@latest --save-dev,
        it probably looks something like this in your package.json: "<package-name>": "*".
        <br />
        Six months from now, when all of your build tools have changed, and the app somehow mysteriously stopped working,
        you'll need to know what exact package version was that "*" when it last worked. And you're not going to know that unless you checked in package-lock.json
        </li>
      </ol>
      `
    }
  };
